import { FC, useMemo } from 'react'
import { Card } from 'antd'
import { Column, ColumnConfig } from '@ant-design/plots'
import { useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'

const config: ColumnConfig = {
	data: [],
	xField: 'title',
	yField: 'value',
	seriesField: 'type',
	isGroup: true,
	columnStyle: {
		radius: [10, 10, 0, 0],
		fillOpacity: 0.8,
	},
	legend: {
		position: 'right',
		padding: [0, 0, 0, 100],
	},
	maxColumnWidth: 30,
}

const BroadcastSuccessMetrics: FC = () => {
	const { views, insights } = useAppSelector(state => state.broadcasts, isEqual)

	const data = useMemo(
		() => [
			{
				title: 'Sent to Delivery',
				value: insights?.sendCount ?? 0,
				type: 'Sent',
			},
			{
				title: 'Sent to Delivery',
				value: insights?.deliveredCount ?? 0,
				type: 'Delivered',
			},
			{
				title: 'Delivered to Engagement',
				value: insights?.deliveredCount ?? 0,
				type: 'Delivered',
			},
			{
				title: 'Delivered to Engagement',
				value: insights?.replies ?? 0,
				type: 'Replies',
			},
			{
				title: 'Sent to Failed',
				value: insights?.sendCount ?? 0,
				type: 'Sent',
			},
			{
				title: 'Sent to Failed',
				value: insights?.failedCount ?? 0,
				type: 'Failed',
			},
		],
		[views, insights]
	)

	return (
		<Card title='Broadcast Success Metrics'>
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<Column {...config} data={data} />
		</Card>
	)
}

export default BroadcastSuccessMetrics
